import { render, staticRenderFns } from "./VehicleConfiguration.vue?vue&type=template&id=16bb71c6&"
import script from "./VehicleConfiguration.vue?vue&type=script&lang=js&"
export * from "./VehicleConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./VehicleConfiguration.vue?vue&type=style&index=0&id=16bb71c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports